export default "__VITE_ASSET__BtQxlD2M__"